export default {
  bind(el, binding, vnode) {
    el.clickOutsideEvent = (event) => {
      let handler = '';
      let isActive = true;
      let exclude = [];
      if (typeof binding.value !== 'object') {
        handler = binding.expression;
      } else {
        ({ handler, exclude, isActive = true } = binding.value);
      }
      // console.log('co -', handler, exclude, isActive, event);
      if (!isActive) {
        return;
      }

      if (event.type === 'mousedown') {
        el.clickedOutsideMouseDown = false;
      }

      let clickedOnExcludedEl = false;
      exclude.forEach(refName => {
        if (!clickedOnExcludedEl) {
          const excludedEl = vnode.context.$refs[refName];
          // console.log('excluded', excludedEl);
          if (excludedEl.$el) {
            clickedOnExcludedEl = excludedEl.$el.contains(event.target);
          } else {
            clickedOnExcludedEl = excludedEl.contains(event.target);
          }
          // console.log('clicked on excluded element');
        }
      });
      if (!(el === event.target || clickedOnExcludedEl || el.contains(event.target))) {
        // console.log('click outside');
        // console.log(vnode);

        if (event.type === 'mousedown') {
          el.clickedOutsideMouseDown = true;
        } else if (event.type === 'mouseup') {
          if (el.clickedOutsideMouseDown) {
            vnode.context[handler](event);
          }
          el.clickedOutsideMouseDown = false;
        }
      }
    };
    document.body.addEventListener('mousedown', el.clickOutsideEvent);
    document.body.addEventListener('mouseup', el.clickOutsideEvent);
    document.body.addEventListener('touchstart', el.clickOutsideEvent);
  },
  unbind: function(el) {
    document.body.removeEventListener('mousedown', el.clickOutsideEvent);
    document.body.removeEventListener('mouseup', el.clickOutsideEvent);
    document.body.removeEventListener('touchstart', el.clickOutsideEvent);
  }
};
